import { ControlsBarContainer, MenuItem, MenuItemContainer, MenuPopup } from "./Components"
import { useNavigate } from "react-router-dom"
import { useContext, useEffect, useState } from "react"
import { WebsiteContext } from "../../context/WebsiteContext"
import { Pause } from "../Player/Pause"
import { Play } from "../Player/Play"
import SlideDownToUp from "../Animation/SlideDownToUp"
import { Statics } from "../General/StaticFiles"
import { AppContext } from "../../context/AppContext"
import { classNames } from "../../helper"
import { Quality } from "../Player/Quality"
import { useTranslation } from "react-i18next"
import { useSwipeable } from "react-swipeable"
import { BottomMenuContainer, BottomMenuWrapper } from "../../templates/desktop/WebsiteTemplate/Components"
import { PageContext } from "../../context/PageContext"
import { PlayerToolbarContext } from "../../context/PlayerToolbarContext"

export const PlayerNavigator = (props) => {
    const {t} = useTranslation();
    const appContext = useContext(AppContext)
    const websiteContext = useContext(WebsiteContext);
    const pageContext = useContext(PageContext);
    const playerToolbarContext = useContext(PlayerToolbarContext);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const {onCompleted, delayToShow} = props;
    const isInPlayer = () => {
        return websiteContext.refPlayer !== null && websiteContext.refPlayer.current !== null;
    }
    const onFullscreenClick = (e) => {
        e.stopPropagation();
        if(!document.fullscreenElement){
            setIsFullscreen(true);
            if(document.documentElement.requestFullScreen) {
                document.documentElement.requestFullScreen();
            } else if(document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if(document.documentElement.webkitRequestFullScreen) {
                document.documentElement.webkitRequestFullScreen();
            }
            
        }else{
            setIsFullscreen(false);
            document.exitFullscreen()
        }
        
    }
    return (
        <BottomMenuContainer id="menu-container" 
            className={classNames([!appContext.isLandscape && "rotate"])} 
            {...pageContext.swipeHandlers}
            onTouchStart={playerToolbarContext.onTouchStart} 
            onMouseMove={playerToolbarContext.onShowMenu} 
            onMouseEnter={playerToolbarContext.onShowMenu} 
            onMouseLeave={playerToolbarContext.onHideMenu}
        >
            {playerToolbarContext.showMenu && 
            <SlideDownToUp isHiding={playerToolbarContext.hidingMenu} onHided={() => playerToolbarContext.setShowMenu(false)}>
                <BottomMenuWrapper id="menu-wraper">
                    <MenuItemContainer id="menu-items" className={
                        classNames([
                            appContext.isLandscape?"landscape":"portrait",
                            "toolbar"
                        ])
                    }>
                        {appContext.isCameFromHome && 
                            <MenuItemNavigator {...props} delay={(delayToShow??0) + 0} name="home">
                                <img src={Statics.HomeIcon} alt={"home"}/>
                            </MenuItemNavigator>
                        }
                        {appContext.isCameFromHome && <MenuItemNavigator {...props} delay={(delayToShow??0) + 500} name={"pmcMusicChannel"}>
                            <img src={Statics.MusicChannelButton} alt={"PMC Channel"}/>
                        </MenuItemNavigator>}
                        {appContext.isCameFromHome && <MenuItemNavigator {...props} delay={(delayToShow??0) + 600} name={"pmcRoyaleChannel"} hasRadio={true}>
                            <img src={Statics.RoyaleChannelButton} alt={"PMC Royale"} />
                        </MenuItemNavigator>}

                        <MenuItemNavigator {...props} delay={(delayToShow??0) + 600} onClick={(e) => {
                            e.stopPropagation();
                            if(isInPlayer()){
                                if(websiteContext.isStreamPlaying){
                                    websiteContext.refPlayer.current.pause();
                                }else{
                                    websiteContext.refPlayer.current.play();
                                }
                            }
                            return null;
                        }}>
                            <ControlsBarContainer>
                                {websiteContext.isStreamPlaying?(
                                    <Pause />
                                ):(
                                    <Play />
                                )}
                            </ControlsBarContainer>
                        </MenuItemNavigator>
                        {appContext.isCameFromHome && <MenuItemNavigator {...props} delay={(delayToShow??0) + 800} name={"pmcSelectRadio"} hasRadio={true}>
                            <img src={Statics.SelectChannelButton} alt={"PMC Select Radio"} />
                        </MenuItemNavigator>}
                        {appContext.isCameFromHome && <MenuItemNavigator {...props} delay={(delayToShow??0) + 1000} name={"pmcPlanetaRadio"} onNextLoad={onCompleted}>
                            <img src={Statics.PlanetaChannelButton} alt={"PMC Planeta Radio"} />
                        </MenuItemNavigator>}
                        <MenuItemNavigator {...props} delay={(delayToShow??0) + 1200} onClick={onFullscreenClick}>
                            {isFullscreen?<img src={Statics.ExitFullscreenIcon} alt={"Exit fullscreen"} />:<img src={Statics.OpenFullscreenIcon} alt={"Open fullscreen"} />}
                        </MenuItemNavigator>
                        {isInPlayer() && websiteContext.refPlayer.current.hasMultiQuality() && 
                        <MenuItemNavigator {...props} delay={(delayToShow??0) + 1400} onClick={(e) => {
                            e.stopPropagation();
                            playerToolbarContext.setIsShowQualityMenu(!playerToolbarContext.isShowQualityMenu)
                        }}>
                            <img src={Statics.CongsIcon} alt={"Settings"} />
                            {playerToolbarContext.isShowQualityMenu && websiteContext.refPlayer.current.showQualityMenu()}
                        </MenuItemNavigator>}
                    </MenuItemContainer>
                </BottomMenuWrapper>
            </SlideDownToUp>
            }
        </BottomMenuContainer>
    )
}
export const MenuItemNavigator = ({onClick, children, name, path, hasRadio, onClickItem}) => {
    const websiteContext = useContext(WebsiteContext)
    const navigate = useNavigate();
    const isInPlayer = () => {
        return websiteContext.refPlayer !== null && websiteContext.refPlayer.current !== null;
    }
    const onClickMenu = (e) => {
        if(onClick) return onClick(e);
        let timeout = 0;
        if(websiteContext.page !== name && isInPlayer()) {
            if(onClickItem) onClickItem();
            websiteContext.refPlayer.current.pause();
            websiteContext.refPlayer.current.remove();
            timeout = 500;
        }
        if(path) return navigate(path);
        websiteContext.update({ 
            page: name??null, 
            menu: false, 
            radio: hasRadio?name:false,
            player: null
        }, timeout);
    }
    return (
        <MenuItem id={`menu-${name}`} onClick={onClickMenu} className={classNames(["menu-item", websiteContext.page === name && "active"])}>
            <div>{children}</div>
        </MenuItem>
    )
}